import { h } from 'preact';
import BaseComponent from './BaseComponent';
import { update } from 'Emitter';
import { UI } from 'StateEvents';

export default class Click extends BaseComponent {
  constructor() {
    super();
  }

  onClick(clickthru) {
    window.open(clickthru, '_blank');
    update(UI.CLICKED, 'onClick');
  }

  render(props) {
    if(props.options.click) {
      return <div class="clickthru clickable full" onClick={ this.onClick.bind(this, props.options.click) }></div>
    }
    
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/Click.js